import { render } from "./sentinel-form.html?vue&type=template&id=386f51b1&scoped=true"
import script from "./sentinel-form.js?vue&type=script&lang=js"
export * from "./sentinel-form.js?vue&type=script&lang=js"

import "./sentinel-form.scss?vue&type=style&index=0&id=386f51b1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-386f51b1"

export default script